// extracted by mini-css-extract-plugin
export default {"sRoundButton":"RectangleButtonMain_sRoundButton__vxLAX"};